var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    { staticClass: "svg-icon" },
    [
      _vm.name === "view"
        ? _c("svg-view", { attrs: { shadow: _vm.shadow, color: _vm.color } })
        : _vm._e(),
      _vm._v(" "),
      _vm.name === "like"
        ? _c("svg-like", { attrs: { shadow: _vm.shadow, color: _vm.color } })
        : _vm.name === "comment"
        ? _c("svg-comment", { attrs: { shadow: _vm.shadow, color: _vm.color } })
        : _vm.name === "information"
        ? _c("svg-information", { attrs: { color: _vm.color } })
        : _vm.name === "panoSelect"
        ? _c("svg-pano-select", { attrs: { color: _vm.color } })
        : _vm.name === "floorplan"
        ? _c("svg-floorplan", { attrs: { color: _vm.color } })
        : _vm.name === "location"
        ? _c("svg-location", { attrs: { color: _vm.color } })
        : _vm.name === "share"
        ? _c("svg-share", { attrs: { color: _vm.color } })
        : _vm.name === "music"
        ? _c("svg-music", { attrs: { color: _vm.color } })
        : _vm.name === "fullscreen"
        ? _c("svg-fullscreen", { attrs: { color: _vm.color } })
        : _vm.name === "gyro"
        ? _c("svg-gyro", { attrs: { color: _vm.color } })
        : _vm.name === "website"
        ? _c("svg-website", { attrs: { color: _vm.color } })
        : _vm.name === "vrmode"
        ? _c("svg-vrmode", { attrs: { color: _vm.color } })
        : _vm.name === "showMobileMenu"
        ? _c("svg-show-mobile-menu", { attrs: { color: _vm.color } })
        : _vm.name === "closeMobileMenu"
        ? _c("svg-close-mobile-menu", { attrs: { color: _vm.color } })
        : _vm.name === "close"
        ? _c("svg-close", { attrs: { color: _vm.color } })
        : _vm.name === "search"
        ? _c("svg-search", { attrs: { color: _vm.color } })
        : _vm.name === "backTo"
        ? _c("svg-back-to", { attrs: { color: _vm.color } })
        : _vm.name === "play"
        ? _c("svg-play", { attrs: { color: _vm.color } })
        : _vm.name === "pause"
        ? _c("svg-pause", { attrs: { color: _vm.color } })
        : _vm.name === "record"
        ? _c("svg-record", { attrs: { color: _vm.color } })
        : _vm.name === "stop"
        ? _c("svg-stop", { attrs: { color: _vm.color } })
        : _vm.name === "pilot"
        ? _c("svg-pilot", { attrs: { color: _vm.color } })
        : _vm.name === "map"
        ? _c("svg-map", { attrs: { color: _vm.color } })
        : _vm.name === "home"
        ? _c("svg-home", { attrs: { color: _vm.color } })
        : _vm.name === "expohall"
        ? _c("svg-expoHall", { attrs: { color: _vm.color } })
        : _vm.name === "agenda"
        ? _c("svg-agenda", { attrs: { color: _vm.color } })
        : _vm.name === "auditorium"
        ? _c("svg-auditorium", { attrs: { color: _vm.color } })
        : _vm.name === "networking"
        ? _c("svg-networking", { attrs: { color: _vm.color } })
        : _vm.name === "sponsor"
        ? _c("svg-sponsor", { attrs: { color: _vm.color } })
        : _vm.name === "visitor"
        ? _c("svg-visitor", { attrs: { color: _vm.color } })
        : _vm.name === "vectorup"
        ? _c("svg-vector-up", { attrs: { color: _vm.color } })
        : _vm.name === "vectordown"
        ? _c("svg-vector-down", { attrs: { color: _vm.color } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }